import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import dayjs from "dayjs";
import VehicleHireStatus from "../../enums/VehicleHireStatus";
const VehicleHireStatusText = ({ vehicleHire, showDate = true }) => {
    if (!vehicleHire || !vehicleHire.status) {
        return null;
    }
    const statusEnum = VehicleHireStatus.valueOf(vehicleHire.status);
    if (!statusEnum) {
        return (_jsx("span", { children: vehicleHire.status }));
    }
    if (!showDate) {
        return statusEnum.renderTag();
    }
    if (statusEnum === VehicleHireStatus.ALLOCATED) {
        if ("allocatedAt" in vehicleHire) {
            const allocatedAt = dayjs(vehicleHire.allocatedAt);
            return (_jsxs("span", { children: [statusEnum.renderTag(), _jsx("br", {}), allocatedAt.format("DD/MM/YYYY HH:mm")] }));
        }
    }
    if (statusEnum === VehicleHireStatus.STARTED) {
        if ("startedAt" in vehicleHire) {
            const startedAt = dayjs(vehicleHire.startedAt);
            return (_jsxs("span", { children: [statusEnum.renderTag(), _jsx("br", {}), startedAt.format("DD/MM/YYYY HH:mm")] }));
        }
    }
    if (statusEnum === VehicleHireStatus.COMPLETED) {
        if ("completedAt" in vehicleHire) {
            const completedAt = dayjs(vehicleHire.completedAt);
            return (_jsxs("span", { children: [statusEnum.renderTag(), _jsx("br", {}), completedAt.format("DD/MM/YYYY HH:mm")] }));
        }
    }
    return statusEnum.renderTag();
};
export default VehicleHireStatusText;
